import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { TScreening } from '../../model/types'
import { COMPETITOR_BAD_ACTOR_REVIEW_TEXT as TEXT, useReviewText } from '../translations'

import { ScreeningRerunDialogContent } from './ScreeningRerunDialogContent'

import styles from './ScreeningRerun.module.scss'

interface IScreeningRerunProps {
  requestId: number
  screening: TScreening
}

export const ScreeningRerun = ({ requestId, screening }: IScreeningRerunProps) => {
  const text = useReviewText()
  const [run, setRun] = useState(0)
  const [open, setOpen] = useState(false)

  const openRun = () => {
    setRun((previous) => previous + 1)
    setOpen(true)
  }

  return (
    <div className={styles.root}>
      <p>{text(TEXT.rerunHint)}</p>
      <Button variant="outlined" onClick={openRun}>
        {text(TEXT.rerunButton)}
      </Button>
      <ModalDialog
        show={open}
        onClose={() => setOpen(false)}
        size="xl"
        closeOnOutsideClick={false}
        title={text(
          screening === 'competitors' ? TEXT.rerunTitleCompetitors : TEXT.rerunTitleBadActors
        )}
        content={ScreeningRerunDialogContent}
        contentProps={{ requestId, screening, run }}
      />
    </div>
  )
}
